<template>
    <h2>Items Requiring Attention</h2>
  <p>{{ pageTitle }}</p>
    <div class="returnLinkButton">
      <div class="material-icons forIconEdit text-success"> arrow_back_ios_new </div>
      <a herf="#" class="text-primary" @click="ReturnToHomepage">
        Return to Home Page
      </a>
    </div>

    <DataTableComponent v-if="this.getAllUrl" :data-url="this.getAllUrl" :column-list-d-b="this.personDataColumnNames"
      :column-list-pretty="this.personDataColumnNamesPretty" column-name-id="personId" :center-column-indexes="[10]"
      :date-column-indexes="[10]" :order-column-index="0" :rows-per-page="RowsPerPageComputed" :show-search="true" plural-data-name="people"
      order-direction="asc" ref="personsDatatable" @dt-results-per-page-changed="ResultsPerPageChanged">
  
      <template v-slot:extraColumnHeaders>
  
        <th>
          <TooltipHelper tooltip-text="Click this button to update the Arming Confirmed Date." position="top">
            Arming Confirmed Date
          </TooltipHelper>
          
        </th>
  
        <th>
          <TooltipHelper tooltip-text="Click the checkbox below to Update the Armed Status on a Person row." position="top">
            Armed
          </TooltipHelper>
  
        </th>
        
      </template>
  
  
      <template #extraColumns="extraColumnRowData">
  
        <td :data-sort="extraColumnRowData.armingConfirmedDate">
          <div class="armingButtonContainer">
            
              <button class="btn btn-secondary btn-sm" @click="ArmingConfirmedButtonClicked(extraColumnRowData)">{{extraColumnRowData.armingConfirmedDatePretty}}</button>
          
            </div>
        </td>
  
        <td :data-sort="extraColumnRowData.armed">
          <div class="form-check activeCheckBoxContainer">
  
            <input class="form-check-input" type="checkbox" value="" :id="'flexCheckDefault_' + extraColumnRowData.personId"
              @change="ActiveCheckboxHit(extraColumnRowData)" v-model="extraColumnRowData.armed">
  
          </div>
        </td>
  
      </template>
  
      <template #actionColumnEditSlot="actionColumnEditSlot">
        <td class="actionColumn tdclass">
          <div class="material-icons forIconEdit text-success actionButton"
            @click="this.ClickedEditPerson(actionColumnEditSlot)" data-tooltip="tooltip" title="Edit Person"
            :id="'btnEditPerson_' + actionColumnEditSlot.personId"> edit </div>
  
          <div class="material-icons forIconTransfer blueButton actionButton" data-tooltip="tooltip"
            title="Transfer Contract for Person" @click="this.ClickedRenewTransferPerson(actionColumnEditSlot)"
            :id="'btnTransferPerson_' + actionColumnEditSlot.personId" v-if="store.authenticatedUser.roleId == 1"> input </div>
  
        </td>
  
      </template>
  
  
    </DataTableComponent>
  </template> 
    
  <script>
  
  import { store } from "@/store/store.js";
  import $ from "jquery";
  import { ajaxGetAndReturn } from "@/components/helpers/utilities";
  import DataTableComponent from "@/components/dataSupport/DataTable.vue";
  import ContractHelperComponent from "@/components/ContractHelper/ContractHelper.vue";
  import TooltipHelper from "@/components/dataSupport/TooltipHelper.vue";
  export default {
    name: "UserContractsTable",
    components: {
      DataTableComponent,
      ContractHelperComponent,
      TooltipHelper,
  
    },
    data() {
      return {
        store,
        contractInfo: {},
        getAllUrl: "",
        personDataColumnNames: ['lastName', 'firstName', 'middleName', 'securityTypeName', 'spotDTSID', 'countryName', 'companyName', 'dodCivYN', 'loaAWYN', 'armingStatus'],
        personDataColumnNamesPretty: ['Last Name', 'First Name', 'Middle Name', 'Security Type', 'LOA', 'Nationality', 'Employer', 'DoD Civillian', 'LOA-AW', 'Status'],
        retrievedContractInfo: false,
        isMounted: false,
        expireTime:0,
      }
    },
    computed: {
      contractId() {
        var computedValue = 0;
  
        if (this.store.tempContractId != undefined && this.store.tempContractId != 0) {
          computedValue = this.store.tempContractId;
        }
        else {
          computedValue = this.$route.params.contractId;
        }
  
        return computedValue;
      },
      companyId() {
        var computedValue = 0;
  
        if (this.store.tempCompanyId != undefined && this.store.tempCompanyId != 0) {
          computedValue = this.store.tempCompanyId;
        }
        else {
          computedValue = this.$route.params.companyId;
        }
  
        return computedValue;
      },
      RowsPerPageComputed(){
        if(this.store.tempMasterPersonListResultsPerPage != 0){
          return this.store.tempMasterPersonListResultsPerPage;
        }
        else{
          return 10; 
        }
      }
    },
    created() {
      ///contracts/getHelperDto/{contractId}
      ajaxGetAndReturn(store.webAPIUrl + "contracts/getHelperDto/" + this.contractId, (result) => {
        //console.log(result);
        this.contractInfo = result;
        this.retrievedContractInfo = true;
  
  
      });
  
      console.log(this.$route.query);
      this.expireTime = this.$route.query.expireTime; 
      this.expireMode = this.$route.query.mode;
 
      switch(this.expireMode){
        case "qual": 
            this.getAllUrl = store.webAPIUrl + "people/GetAllPersonsByContractAndExpireTime?contractId=" + this.contractId + "&expireTime=" + this.expireTime;
            if(this.expireTime ==0) this.pageTitle = "This is a list of individuals with Expired Weapons Qualification Dates."
            else this.pageTitle = "This is a list of individuals with Weapon Qualification Dates That will Expire within [" + this.expireTime + "] Days.";
        break; 
        case "deploy": 
            this.getAllUrl = store.webAPIUrl + "people/GetAllPersonsByContractAndDeployTime?contractId=" + this.contractId + "&deployTime=" + this.expireTime;
            if(this.expireTime ==0) this.pageTitle = "This is a list of individuals with Expired Contract End Deploy Dates"
            else this.pageTitle = "This is a list of individuals with Contract End Deploy Dates That will Expire within [" + this.expireTime + "] Days.";
        break; 
        case "confirm": 
            this.getAllUrl = store.webAPIUrl + "people/GetAllPersonsByContractAndConfirmTime?contractId=" + this.contractId;
            this.pageTitle = "This is a list of individuals with Confirm Dates Over 30 Days Past.";
        break; 
      }
     
    },
    mounted() {
      //var urlParams = this.$route.params.contractId;
  
      $("");
  
      this.isMounted = true;
    },
  
    methods: {
      ClickedEditContract() {
        alert('edit contract with Id: ' + this.contractInfo.contractId + "; contract number: " + this.contractInfo.contractNumber);
      },
  
      ClickedRenewTransferPerson(persObj) {
  
        //console.log(persObj);
        // alert('renew/transfer person: ' + persObj.personId + " | lastname, firstName: " + persObj.lastName + ", " + persObj.firstName);
        this.$router.push({
          name: 'personTransfer',
          params: {
            personID: persObj.personId,
            firstName: persObj.firstName,
            lastName: persObj.lastName,
            contractId: this.contractInfo.contractId,
            contractNumber: this.contractInfo.contractNumber
          }
        });
      },
      ClickedEditPerson(persObj) {
        this.store.tempPersonId = persObj.personId;
        this.$router.push({ name: 'PersonEditPage', params: { personId: persObj.personId } });
      },
      //Add A Person
      ClickedAddAPerson() {
        // alert("add a person");
  
        // console.log('this.contractInfo.contractId = ', this.contractInfo.contractId);
        // console.log('this.contractInfo.contractNumber = ', this.contractInfo.contractNumber);
        this.$router.push({
          name: 'addPerson',
          params: {
            contractId: this.contractInfo.contractId,
            contractNumber: this.contractInfo.contractNumber
          }
        });
  
      },
      //Upload Single Doc/Multiple Individuals
      ClickedUploadSingleDocMultIndividuals() {
        alert("upload a single doc/multiple individuals");
      },
      //Multi-Individual Transfer 
      ClickedMultiIndividualTransfer() {
        // console.log('--- ClickedMultiIndividualTransfer ---');
        // console.log('this.contractInfo.contractId = ', this.contractInfo.contractId);
        // console.log('this.contractInfo.contractNumber = ', this.contractInfo.contractNumber);
  
        this.$router.push({
          name: 'multiPersonTransfer',
          params: {
            contractId: this.contractInfo.contractId,
            contractNumber: this.contractInfo.contractNumber
          }
        });
  
      },
      //Transfer/Renewal Insructions 
      ClickedTransferRenewalInstructions() {
        alert("Transfer/Renewal Insructions");
      },
      //Master Document Upload
      ClickedMasterDocumentUpload() {
        alert("Master Document Upload");
      },
      ActiveCheckboxHit(rowData) {
        //console.log(rowData);
  
        //get dataTable row by Id:
        var DataRowToEdit = this.$refs.personsDatatable.loadedData.find(x => x.personId == rowData.personId);
        //update data in table:
        DataRowToEdit.armed = rowData.armed != null ? rowData.armed : true;
        DataRowToEdit.armedYN = rowData.armed ? "Yes" : "No";
        DataRowToEdit.armingConfirmedDatePretty = this.GetTodaysDatePretty();
        //update data in DB:
        //PUT: api/People/5
        var actionUrl = store.webAPIUrl + "People/putPersonDto/" + rowData.personId;
  
        //set update date to now
        rowData.updateDate = new Date();
        rowData.armingConfirmedDate = new Date();
        rowData.isActive = true;
        rowData.armed = DataRowToEdit.armed;
  
        $.ajax({
          method: "PUT",
          contentType: "application/json; charset=utf-8",
          dataType: "json",
          url: actionUrl,
          data: JSON.stringify(rowData),
          success: (result) => {
  
            this.successMessage = "Successfully Submitted Change to DB on: " + Date().toLocaleString() + "; " + result;
          },
        });
      },
      GetTodaysDatePretty() {
        var today = new Date();
        var dd = today.getDate();
  
        var mm = today.getMonth() + 1;
        var yyyy = today.getFullYear();
        if (dd < 10) {
          dd = '0' + dd;
        }
  
        if (mm < 10) {
          mm = '0' + mm;
        }
  
        return (mm + "/" + dd + "/" + yyyy);
      },
      ReturnToHomepage() {
        this.$router.push({ name: 'home' });
      },
      ArmingConfirmedButtonClicked(rowData){
        console.log(rowData);
        var DataRowToEdit = this.$refs.personsDatatable.loadedData.find(x => x.personId == rowData.personId);
  
        DataRowToEdit.armingConfirmedDatePretty = this.GetTodaysDatePretty();
        var actionUrl = store.webAPIUrl + "People/putPersonDto/" + rowData.personId;
  
        //set update date to now
        rowData.updateDate = new Date();
        rowData.armingConfirmedDate = new Date();
        rowData.isActive = true;
  
        $.ajax({
          method: "PUT",
          contentType: "application/json; charset=utf-8",
          dataType: "json",
          url: actionUrl,
          data: JSON.stringify(rowData),
          success: (result) => {
  
            this.successMessage = "Successfully Submitted Change to DB on: " + Date().toLocaleString() + "; " + result;
          },
        });
      },
      ResultsPerPageChanged(len){
        //console.log("picking up length change in master list: ", len);
        this.store.tempMasterPersonListResultsPerPage = len;
      }
    },
    unmounted() {
  
      //console.log("force update user contracts table"); 
      this.$forceUpdate();
    }
  }
  </script>
    
  <style scoped>
  .returnLinkButton {
    display: flex;
    margin-bottom: 15px;
  }
  
  .actionButton {
    width: max-content;
    padding: 5px;
    cursor: pointer;
  }
  
  .btnAndTooltipContainer {
    display: flex;
    justify-content: space-around;
    font-size: 14px;
    gap: 20px;
    width: 80%;
    align-content: center;
    margin-left: auto;
    margin-right: auto;
  }
  
  .btnAndTooltipContainer div {
    align-items: center;
  }
  
  .activeCheckBoxContainer {
    padding-bottom: 1.25rem;
  }
  
  .blueButton {
    color: #1063a8;
  }
  
  .form-check-input {
    cursor: pointer;
    margin-right: 5px;
  }
  </style>
  